import { capitalizeStringUtil } from 'packages/src'
import {
  PLAN_CLASS_NAME,
  WORKOUT_CLASS_NAME
} from '@gymaholic/packages'
import { APP_INITIAL_TEMPLATE } from 'constants/app'
import { BRAND_DESCRIPTION } from 'constants/brand.js'
import { ARTICLE_MODEL_CLASS_NAME } from 'models/daos/article/constants'
import { MOTIVATION_MODEL_CLASS_NAME } from 'models/daos/motivation/constants'
import { PAGE_MODEL_CLASS_NAME } from 'models/daos/page/constants'
import { getUrlReduxUtil } from 'modules/redux/utils/get-url'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import getImageUrlPlanUtil from 'modules/training/models/plan/utils/get-image-url'
import getImageUrlWorkoutUtil from 'modules/training/models/workout/utils/get-image-url'
import { compactObjectUtil } from 'utils/object'
import { replaceLineBreaksToSpacesStringUtil } from 'utils/string/replace-line-breaks-to-spaces'
import getPagePropertiesFromInstanceReduxUtil from 'modules/redux/utils/get-page-properties-from-instance/index.js'

/**
 * @param props
 * @param props.instance
 * @param props.pathname
 * @param props.state
 * @param props.intl
 * @return {{image: string, description: string, title: string, type: string, url: string, tags: *}}
 */
export default function getPagePropertiesReduxUtil (props) {
  const {
    instance,
    pathname,
    state,
    intl
  } = props

  let pageProps = {
    ...APP_INITIAL_TEMPLATE
  }

  if (!instance) {
    let title = pathname.split('/')[1].replace(/-/gi, ' ')
    if (title.indexOf('?') >= 0) {
      title = title.slice(0, title.indexOf('?') + 1)
    }
    const res = {
      ...pageProps
    }
    if (title) {
      res.title = capitalizeStringUtil(title)
    }

    if (title) {
      res.description = `${title}. ${BRAND_DESCRIPTION}`
    }

    return res
  }

  let tags = getValueReduxUtil(instance, 'tags')
  if (tags && Array.isArray(tags)) {
    tags = getValueReduxUtil(instance, 'tags')
      .map(tag => getValueReduxUtil(tag, 'name'))
      .join(',')
  }

  let type
  const { className } = instance
  if (
    className &&
    [
      ARTICLE_MODEL_CLASS_NAME,
      MOTIVATION_MODEL_CLASS_NAME,
      PAGE_MODEL_CLASS_NAME
    ].includes(className)
  ) {
    type = 'article'
  }

  let image
  if (className === WORKOUT_CLASS_NAME) {
    image = getImageUrlWorkoutUtil(instance)
  } else if (className === PLAN_CLASS_NAME) {
    image = getImageUrlPlanUtil(instance)
  }

  pageProps = {
    ...pageProps,
    ...compactObjectUtil({
      title: (
        getValueReduxUtil(instance, 'title') ||
        getValueReduxUtil(instance, 'name')
      ),
      description: replaceLineBreaksToSpacesStringUtil(
        getValueReduxUtil(instance, 'description') ||
        getValueReduxUtil(instance, 'notes')
      ),
      image: (
        image ||
        getValueReduxUtil(instance, 'shareImg') ||
        getValueReduxUtil(instance, 'image') ||
        getValueReduxUtil(instance, 'img')
      ),
      tags,
      url: getUrlReduxUtil(instance),
      type
    }),
    ...getPagePropertiesFromInstanceReduxUtil({
      instance,
      state,
      intl
    })
  }

  // Add protocol to the image
  if (
    pageProps.image &&
    pageProps.image.indexOf('//') === 0
  ) {
    pageProps.image = pageProps.image.replace(
      '//',
      'https://'
    )
  }

  return pageProps
}
